/**
 * Admin — santé système (bloc 1).
 *
 * Taille de la base (critique en infra frugale) + compteurs. Lecture seule.
 */
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Layout } from "@/components/Layout";
import { getAdminHealth } from "@/api/admin";

export default function AdminHealthPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin", "health"],
    queryFn: getAdminHealth,
  });

  return (
    <Layout>
      <div className="mx-auto max-w-4xl px-6 py-12">
        <Link to="/admin" className="text-sm text-blue-900 underline">
          ← Admin
        </Link>
        <h1 className="mt-3 text-2xl font-bold">Santé système</h1>

        {isLoading && <p className="mt-6 text-sm text-gray-500">Chargement…</p>}
        {error && (
          <p className="mt-6 text-sm text-red-700">Impossible de charger l'état système.</p>
        )}

        {data && (
          <>
            <section className="mt-6 rounded-lg border border-gray-200 bg-white p-5">
              <div className="text-xs uppercase tracking-wide text-gray-500">
                Taille de la base de données
              </div>
              <div className="mt-1 text-2xl font-bold text-blue-900">
                {data.db_size_pretty}
              </div>
              <div className="text-xs text-gray-500">
                {data.db_size_bytes.toLocaleString("fr-FR")} octets
              </div>
            </section>

            <section className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
              <Kpi label="Utilisateurs" value={data.users} />
              <Kpi label="Logements" value={data.logements} />
              <Kpi label="DPE (total)" value={data.dpe_total} />
              <Kpi label="DPE calculés" value={data.dpe_calcule} />
              <Kpi label="DPE brouillons" value={data.dpe_brouillon} />
              <Kpi label="Suppressions en attente" value={data.pending_deletions} />
            </section>
          </>
        )}
      </div>
    </Layout>
  );
}

function Kpi({ label, value }: { label: string; value: number }) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="text-2xl font-bold text-blue-900">{value}</div>
      <div className="mt-1 text-xs uppercase tracking-wide text-gray-500">{label}</div>
    </div>
  );
}
